var React = require('react');

function BackInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n            .cls-2{fill:none;stroke:#1a1a1a;stroke-width:3px;stroke-linecap:square}\n        ")),React.createElement("g",{"id":"btn_back","transform":"translate(-346 -43)","key":1},React.createElement("g",{"id":"그룹_4446","transform":"translate(-1134 -43)"},[React.createElement("path",{"id":"선_97","d":"M11 0L0 11","className":"cls-2","transform":"translate(1495 105)","key":0}),React.createElement("path",{"id":"선_99","d":"M11 11L0 0","className":"cls-2","transform":"translate(1495 116)","key":1}),React.createElement("path",{"id":"선_98","fill":"none","stroke":"#1a1a1a","strokeWidth":"3px","d":"M0 0L29 0","transform":"translate(1496 116)","key":2})]))]);
}

BackInline.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60"};

module.exports = BackInline;

BackInline.default = BackInline;
